import React, {useState, useEffect} from "react";
import {
    Box,

    CssBaseline,
    Typography, InputBase, Paper, Grid, IconButton, LinearProgress, CircularProgress, Button
} from "@mui/material";
import {SearchRounded} from "@mui/icons-material";
import {useSearchParams} from "react-router-dom";
import Dialog from "../SearchEngineDialog";
import SearchEngineDialog from "../SearchEngineDialog";
import bing from "../../img/bing.png"
import yahoo from "../../img/yahoo.png"
import logo from "../../img/T.png"

function Search() {


    const [keyword, setKeyword] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searchEngine, setSearchEngine] = useState(null);
    const [selectedValue, setSelectedValue] = React.useState(null);
    const [open, setOpen] = React.useState(false);


    const [searchParams, setSearchParams] = useSearchParams();
    const searchUrl = searchEngine == "Bing" ? "https://www.bing.com/search?q=" : "https://search.yahoo.com/search?p="



    useEffect(() => {

        const q = searchParams.get('q')
        localStorage.getItem('search') ? setSearchEngine(localStorage.getItem('search')) : setSearchEngine("Bing")


        setLoading(false)


    }, []);


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
        if (!value) return
        localStorage.setItem('search', value)
        setSearchEngine(value);
    };






    if (loading) return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{minHeight: '90vh', textAlign: "center"}}
        >
            <CircularProgress/>

        </Grid>)

    return (
        <Box maxWidth={"xs"}>
            <CssBaseline/>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{minHeight: '90vh', textAlign: "center"}}
            >
                <Grid item xs={3}>

                    <Typography component={"h1"} variant={"h5"}>
                        <img src={logo} width={48}/>
                    </Typography>
                    <Paper
                        action={searchUrl}
                        method={"GET"}
                        component="form"
                        sx={{
                            p: '2px 4px',
                            mt: 2,
                            display: 'flex',
                            borderRadius: 5,
                            border: 1,
                            mx: "auto",
                            borderColor: 'grey.500',
                            minWidth: 350
                        }}

                    >

                        <InputBase
                            sx={{ml: 1, flex: 1}}
                            name={"q"}
                            placeholder="Type in ..."
                            inputProps={{'aria-label': 'type in ...'}}

                            onChange={(event) => setKeyword(event.target.value)}
                        />
                        <IconButton type="button" sx={{p: '10px'}} aria-label="search"  type={"submit"}
                                    disabled={!keyword}>
                            {/*<SearchRounded sx={{color: "lightblue"}}/>*/}
                            {!keyword ?
                                <img src={searchEngine == "Bing" ? bing : yahoo} width={24}
                                     style={{filter: "grayscale(100%)", opacity: "0.25"}}/>
                                :
                                <img src={searchEngine == "Bing" ? bing : yahoo} width={24}/>}
                        </IconButton>
                    </Paper>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item>
                            <Typography component={"h5"} sx={{mt: 1}} variant={"caption"} textAlign={'right'}>
                                <a href="https://chrome.google.com/webstore/detail/typcom-search-for-chrome/dpicpabgigbiknnbphpkiocabddkbmdf"
                                   sx={{textdecoration: "none", color: "grey.900"}} rel="noreferrer" target={"_blank"}>Install
                                    Extension</a>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography component={"h5"} sx={{mt: 1}} variant={"caption"} textAlign={'right'}>
                                Search powered by <Button href="#change" sx={{p: 0, m: 0}} size={"small"}
                                                          onClick={handleClickOpen}>{searchEngine}</Button>
                            </Typography>
                            <SearchEngineDialog selectedValue={selectedValue}
                                                open={open}
                                                onClose={handleClose}/>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


            <Paper sx={{
                marginTop: 'calc(10% + 60px)',
                position: 'fixed',
                bottom: 0,
                width: '100%'
            }} component="footer" square variant="outlined">
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row-reverse',
                    p: 1,
                    m: 1,
                    borderRadius: 1,
                    gap: 2,

                }}>
                    <div>© 2022 Typ Network, Pte Ltd</div>
                    <div><a href="https://www.typ.com/privacy" sx={{textdecoration: "none", color: "grey.900"}}
                            rel="noreferrer"
                            target={"_blank"}>Privacy</a></div>
                    <div><a href="https://app.typ.com" sx={{textdecoration: "none", color: "grey.900"}} rel="noreferrer"
                            target={"_blank"}>Partners</a></div>
                    <div><a
                        href="https://chrome.google.com/webstore/detail/typcom-search-for-chrome/dpicpabgigbiknnbphpkiocabddkbmdf"
                        sx={{textdecoration: "none", color: "grey.900"}} rel="noreferrer"
                        target={"_blank"}>Extension</a></div>

                </Box>

            </Paper>
        </Box>

    )
}

export default Search